import type { GameConfig, GameKey } from "./types";

const powerplay10x = { 10: 1 / 43, 5: 2 / 43, 4: 3 / 43, 3: 13 / 43, 2: 24 / 43 };
const powerplayNo10x = { 5: 2 / 42, 4: 3 / 42, 3: 13 / 42, 2: 24 / 42 };
const megaMultiplier = { 2: 15 / 32, 3: 10 / 32, 4: 4 / 32, 5: 2 / 32, 10: 1 / 32 };

export const games: Record<GameKey, GameConfig> = {
  powerball: {
    key: "powerball",
    name: "Powerball",
    whiteMax: 69,
    bonusMax: 26,
    ticketCost: 2,
    drawDays: [0, 2, 5],
    drawTimeEt: "22:59",
    jackpotCashDefault: 40_000_000,
    currentRuleStart: "2015-10-07",
    officialNotes: "5/69 + 1/26; jackpot odds 1 in 292,201,338.",
    whitePick: 5,
    lowerTiers: [
      { name: "5 white", whiteHits: 5, bonusHit: false, basePrizeCash: 1_000_000, powerplayMatch5Fixed2m: true },
      { name: "4 white + Powerball", whiteHits: 4, bonusHit: true, basePrizeCash: 50_000 },
      { name: "4 white", whiteHits: 4, bonusHit: false, basePrizeCash: 100 },
      { name: "3 white + Powerball", whiteHits: 3, bonusHit: true, basePrizeCash: 100 },
      { name: "3 white", whiteHits: 3, bonusHit: false, basePrizeCash: 7 },
      { name: "2 white + Powerball", whiteHits: 2, bonusHit: true, basePrizeCash: 7 },
      { name: "1 white + Powerball", whiteHits: 1, bonusHit: true, basePrizeCash: 4 },
      { name: "Powerball only", whiteHits: 0, bonusHit: true, basePrizeCash: 4 }
    ],
    powerplayAvailable: true,
    powerplayDistribution10x: powerplay10x,
    powerplayDistributionNo10x: powerplayNo10x
  },
  mega_millions: {
    key: "mega_millions",
    name: "Mega Millions",
    whiteMax: 70,
    bonusMax: 24,
    ticketCost: 5,
    drawDays: [1, 4],
    drawTimeEt: "23:00",
    jackpotCashDefault: 50_000_000,
    currentRuleStart: "2025-04-08",
    officialNotes: "5/70 + 1/24; $5 ticket includes built-in multiplier; jackpot odds 1 in 290,472,336.",
    whitePick: 5,
    builtinMultiplierDistribution: megaMultiplier,
    lowerTiers: [
      { name: "5 white", whiteHits: 5, bonusHit: false, basePrizeCash: 1_000_000, multiplierApplies: true },
      { name: "4 white + Mega Ball", whiteHits: 4, bonusHit: true, basePrizeCash: 10_000, multiplierApplies: true },
      { name: "4 white", whiteHits: 4, bonusHit: false, basePrizeCash: 500, multiplierApplies: true },
      { name: "3 white + Mega Ball", whiteHits: 3, bonusHit: true, basePrizeCash: 200, multiplierApplies: true },
      { name: "3 white", whiteHits: 3, bonusHit: false, basePrizeCash: 10, multiplierApplies: true },
      { name: "2 white + Mega Ball", whiteHits: 2, bonusHit: true, basePrizeCash: 10, multiplierApplies: true },
      { name: "1 white + Mega Ball", whiteHits: 1, bonusHit: true, basePrizeCash: 7, multiplierApplies: true },
      { name: "Mega Ball only", whiteHits: 0, bonusHit: true, basePrizeCash: 5, multiplierApplies: true }
    ]
  },
  millionaire_for_life: {
    key: "millionaire_for_life",
    name: "Millionaire for Life",
    whiteMax: 58,
    bonusMax: 5,
    ticketCost: 5,
    drawDays: [0, 1, 2, 3, 4, 5, 6],
    drawTimeEt: "23:15",
    jackpotCashDefault: 18_000_000,
    currentRuleStart: "2026-02-22",
    officialNotes: "5/58 + 1/5; fixed top-prize cash option used here is $18M.",
    topPrizeFixedCash: true,
    whitePick: 5,
    lowerTiers: [
      { name: "5 white", whiteHits: 5, bonusHit: false, basePrizeCash: 2_200_000 },
      { name: "4 white + Millionaire Ball", whiteHits: 4, bonusHit: true, basePrizeCash: 7_500 },
      { name: "4 white", whiteHits: 4, bonusHit: false, basePrizeCash: 500 },
      { name: "3 white + Millionaire Ball", whiteHits: 3, bonusHit: true, basePrizeCash: 250 },
      { name: "3 white", whiteHits: 3, bonusHit: false, basePrizeCash: 50 },
      { name: "2 white + Millionaire Ball", whiteHits: 2, bonusHit: true, basePrizeCash: 25 },
      { name: "2 white", whiteHits: 2, bonusHit: false, basePrizeCash: 8 },
      { name: "1 white + Millionaire Ball", whiteHits: 1, bonusHit: true, basePrizeCash: 8 }
    ]
  }
};

export const gameKeys = Object.keys(games) as GameKey[];
